import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const UPDATE_COMPANY_BENEFIT_INVOICE = gql`
  mutation UpdateCompanyBenefitInvoice($updatedCompanyBenefitInvoice: UpdateCompanyBenefitInvoiceRequestDto!) {
    updateCompanyBenefitInvoice(updatedCompanyBenefitInvoice: $updatedCompanyBenefitInvoice) {
      amountExcludingVat
      amountExcludingVatEur
      benefitType
      comment
      companyBenefitInvoiceFileUuid
      createdAt
      currency
      invoiceDate
      month
      totalAmount
      totalAmountEur
      uuid
      vatList {
        vatAmount
        vatRate
      }
      year
    }
  }
`;

export const useUpdateCompanyBenefitInvoice = () => {
    const [updateCompanyBenefitInvoice, { loading, error, data }] = useMutation(UPDATE_COMPANY_BENEFIT_INVOICE);

    return { updateCompanyBenefitInvoice, loading, error, data };
};
